import type { Locale } from 'date-fns';
import { enUS, es, ptBR } from 'date-fns/locale';
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_LABELS,
  LANGUAGE_TAGS,
  SUPPORTED_LANGUAGES,
  UserLanguage,
  isUserLanguage,
} from '@xtreed/academy-shared';

interface LanguageConfig {
  tag: string;
  label: string;
  short: string;
  dateLocale: Locale;
}

const DATE_LOCALES: Record<UserLanguage, Locale> = {
  [UserLanguage.ES_ES]: es,
  [UserLanguage.PT_BR]: ptBR,
  [UserLanguage.EN_US]: enUS,
};

export { DEFAULT_LANGUAGE, isUserLanguage };

export const LANGUAGE_OPTIONS: UserLanguage[] = [...SUPPORTED_LANGUAGES];

export const LANGUAGES = Object.fromEntries(
  LANGUAGE_OPTIONS.map((language) => [
    language,
    {
      tag: LANGUAGE_TAGS[language],
      label: LANGUAGE_LABELS[language],
      short: LANGUAGE_TAGS[language].slice(0, 2).toUpperCase(),
      dateLocale: DATE_LOCALES[language],
    },
  ]),
) as Record<UserLanguage, LanguageConfig>;

export function languageFromTag(tag: string | undefined): UserLanguage {
  const found = LANGUAGE_OPTIONS.find((key) => LANGUAGES[key].tag === tag);
  return found ?? DEFAULT_LANGUAGE;
}
